import React from 'react';
import clsx from 'clsx';
import styles from './Stack.module.scss';

/**
 * Stack
 *
 * Layout component for arranging children in a vertical or horizontal stack
 * with consistent spacing.
 *
 * Props:
 * - as: Element type to render (default: 'div')
 * - direction: 'vertical' | 'horizontal' (default: 'vertical')
 * - gap: spacing token - 'xs' | 'sm' | 'md' | 'lg' | 'xl' (default: 'md')
 * - align: alignment - 'start' | 'center' | 'end' | 'stretch'
 * - justify: justification - 'start' | 'center' | 'end' | 'between' | 'around'
 * - className: optional additional class
 */
const Stack = ({
  as: Component = 'div',
  direction = 'vertical',
  gap = 'md',
  align,
  justify,
  className,
  children,
  ...props
}) => {
  return (
    <Component
      className={clsx(
        styles.stack,
        styles[`stack--${direction}`],
        styles[`stack--gap-${gap}`],
        align && styles[`stack--align-${align}`],
        justify && styles[`stack--justify-${justify}`],
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Stack;
